import { render } from "./IconHandThumbUpRegular.vue?vue&type=template&id=4a7f6551"
const script = {}
script.render = render

export default script